<template>
  <BaseInputText
    v-model="search"
    :aria-label="ariaLabel"
    :aria-labelledby="ariaLabelledby"
    :class="`c-base-search-input c-base-search-input--${variant}`"
    :clearable="clearable"
    data-testid="base-search-input"
    :label="label"
    new-design
    :placeholder="placeholder"
    rounded
  >
    <template #prepend>
      <BaseIcon
        class="tw:text-2xl"
        data-testid="base-search-input-icon"
        icon="search"
      />
    </template>
  </BaseInputText>
</template>

<script lang="ts" setup>
import { BaseIcon, BaseInputText } from "shared/components/base";

type BaseSearchInputVariant = "dark" | "light";

withDefaults(
  defineProps<{
    ariaLabel?: string;
    ariaLabelledby?: string;
    clearable?: boolean;
    label?: string;
    placeholder?: string;
    variant?: BaseSearchInputVariant;
  }>(),
  {
    ariaLabel: undefined,
    ariaLabelledby: undefined,
    label: undefined,
    placeholder: "",
    variant: "light",
  }
);

const search = defineModel<string>({
  required: true,
});
</script>

<style lang="scss" scoped>
.c-base-search-input {
  :deep(.input-wrapper) {
    --c-input-padding-inline: 4px;

    input {
      padding-left: 10px;
    }
  }

  &--light :deep(.input-wrapper) {
    --c-input-border-color: var(--s-color-denim-2);
    --c-input-color: var(--s-color-denim-9);

    input::placeholder {
      color: var(--s-color-denim-9);
    }
  }

  &--dark :deep(.input-wrapper) {
    --c-input-border-color: transparent;
    --c-input-color: #fff;

    background: rgb(255 255 255 / 15%);

    input {
      color: #fff;

      &::placeholder {
        color: var(--s-color-denim-4);
      }
    }

    .clear-icon {
      color: var(--s-color-denim-4);
    }

    .clear {
      padding-right: 0.4em;
    }

    .s-icon-search {
      color: var(--s-color-denim-4);
    }

    &:focus-within {
      --c-input-border-color: var(--s-color-denim-2);
    }
  }

  &--dark {
    &.is-keyboard-focus :deep(.input-wrapper) {
      --c-input-border-color: transparent;

      outline-color: var(--s-color-denim-2);
    }

    :deep(.clear-icon:focus-visible) {
      outline-color: var(--s-color-denim-2);
    }
  }
}
</style>
